import columnTypes from '../columnTypes.js';
import types from '../types.js';

const combinedPAMTables = [
  {
    key: 'Violation-Stock-And-Flow',
    name: 'Violation Stock And Flow',
    [columnTypes.default.key]: [
      {
        source: 'MetricDate',
        rename: 'Metric Date',
        type: types.date,
      },
      {
        source: 'StockCount',
        rename: 'Stock Count',
        type: types.number,
      },
      {
        source: 'FlowCount',
        rename: 'Flow Count',
        type: types.number,
      },
      {
        source: 'RemediationsCount',
        rename: 'Remediations Count',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [],
    [columnTypes.hidden.key]: [],
  },
];

export default [...combinedPAMTables];
